import { ReactNode } from 'react';

import cn from 'classnames';

interface ErrorScreenProps {
  message: ReactNode;
  // should return content as child block for other screens when true
  asChild?: boolean;
}

export const ErrorScreen = ({ message, asChild = false }: ErrorScreenProps) => (
  <div
    className={cn(`flex h-full flex-col items-center justify-center p-4`, {
      'min-h-screen': !asChild,
    })}
  >
    <p className="text-gray-500">{message}</p>
  </div>
);
